/**
 * The phone roster: venues as a stack of cards (BON-538).
 *
 * The cards sit OUTSIDE the roster card's own padding in the design — they have
 * their own borders and their own colour stripe, so nesting them inside a second
 * bordered surface would draw two frames around every venue.
 */
import type { ReactNode } from 'react';

import { venueHref } from './venue-routes';
import { VenueCard } from './VenueCard';
import type { VenueRosterRow } from './venues-roster-api';

export interface VenueCardStackProps {
  venues: readonly VenueRosterRow[];
  empty: ReactNode;
}

export function VenueCardStack({ venues, empty }: VenueCardStackProps) {
  if (venues.length === 0) return <>{empty}</>;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        padding: '4px 16px 16px',
      }}
    >
      {venues.map((venue) => (
        <VenueCard key={venue.id} venue={venue} href={venueHref(venue)} />
      ))}
    </div>
  );
}
